<template>
    <div class="block-current-openings">
        <div class="capper">
            <div class="capper-padded">
                <div class="title-row" data-aos="fade-up">
                    <div class="title-row2">
                        <span class="txt">Current Openings</span>
                        <div class="filter-outer" v-if="jobs && jobs.length">
                            <div class="filter" @click="openFilterSidebar">
                                <div
                                    v-if="showClearFilter"
                                    @click.stop="clearFilter"
                                    class="close-button small">
                                </div>
                                <div class="txt">Filter</div>
                                <FilterIcon class="icon-filter"/>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="jobs-container" v-if="jobs && jobs.length">
                    <!-- Header Row -->
                    <div class="job-row header" data-aos="fade-up">
                        <div class="job-cell position">Position</div>
                        <div class="job-cell location">Employee Type</div>
                        <div class="job-cell department">Department</div>
                        <!--

                        <div class="job-cell location">Location</div>
                        -->
                    </div>
                    <a
                        class="job-row regular"
                        v-for="job in filteredJobs"
                        :key="job.id"
                        :href="job.absolute_url"
                        target="_blank"
                        aria-label="Job Link"
                    >
                        <div data-aos="fade-up" class="job-cell position">{{ job.title }}</div>
                        <div data-aos="fade-up" class="job-cell location">{{ job.fullTime }}</div>
                        <div data-aos="fade-up" class="job-cell department">{{ getDepartment(job) }}</div>

                        <div data-aos="fade-up" class="job-cell mobile-department-location">
                            {{ job.fullTime }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ getDepartment(job) }}
                        </div>

                        <!--
                        <div data-aos="fade-up" class="job-cell mobile-department-location">{{
                                getDepartment(job)
                            }}
                        </div>

                        <div data-aos="fade-up" class="job-cell department">{{ getDepartment(job) }}</div>
                        <div data-aos="fade-up" class="job-cell location">{{ job.location.name }}</div>
<div data-aos="fade-up" class="job-cell mobile-department-location">{{ getDepartment(job) }}&nbsp;&nbsp;|&nbsp;&nbsp;{{ job.location.name }}</div>
                        -->
                    </a>
                </div>

                <div class="jobs-container" v-else>
                    <div class="job-row header" data-aos="fade-up">
                        <div class="job-cell position">Position</div>
                        <div class="job-cell department">Department</div>
                        <div class="job-cell location">Location</div>
                    </div>

                    <div class="no-openings" data-aos="fade-up">
                        <div class="no-openings2">

                                <h2>There are no job openings at this time.</h2>
                                <p >Please check back later for future opportunities.</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import FilterIcon from "@/components/svgs/FilterIcon.vue";

export default {
    name: "CurrentOpenings",
    components: {FilterIcon},
    props: {},
    data() {
        return {
            jobs: [],
            departments: [],
            selectedFilters: [],
        };
    },
    computed: {
        ...mapState({
            careersJson: state => state.careersJson,
            selectedDepartmentFilters: state => state.selectedDepartmentFilters
        }),
        filteredJobs() {
            // If the "All Departments" filter is active, return all jobs.
            if (this.selectedDepartmentFilters.some(filter => filter.slug === "all")) {
                return this.jobs;
            }
            // Otherwise, filter jobs by matching the department slug.
            return this.jobs.filter(job => {
                const deptMeta = job.metadata.find(m => m.name === "Career Page - Sub Department");
                if (!deptMeta || !deptMeta.value) return false;
                // Generate the slug for the job's department.
                const jobDeptSlug = deptMeta.value
                    .toLowerCase()
                    .replace(/[^a-z0-9]+/g, "-")
                    .replace(/^-+|-+$/g, "");
                return this.selectedDepartmentFilters.some(filter => filter.slug === jobDeptSlug);
            });
        },
        showClearFilter() {
            // If the only selected filter is "All Departments", don't show the clear button.
            if (
                this.selectedDepartmentFilters.length === 1 &&
                this.selectedDepartmentFilters[0].slug === "all"
            ) {
                return false;
            }
            return this.selectedDepartmentFilters.length > 0;
        }
    },
    mounted() {
        if (this.careersJson !== null && this.careersJson !== 'error') {
            this.jobs = this.careersJson
            this.convertTitleToFullTimeness()

            this.loadJobsData()
        } else {
            fetch("https://boards-api.greenhouse.io/v1/boards/insomniac/jobs?content=true")
                .then((response) => response.json())
                .then((data) => {
                    // Store the jobs array
                    this.jobs = data.jobs;
                    this.convertTitleToFullTimeness()

                    this.$store.commit("setCareersJson", this.jobs);
                    this.loadJobsData()
                })
                .catch((error) => {
                    this.$store.commit("setCareersJson", 'error');
                    console.error("Error fetching jobs:", error)
                });
        }

    },
    methods: {
        convertTitleToFullTimeness() {
            // "contract" or "contractor" as a whole word, any case, anywhere in the title
            const contractWord = /\bcontract(or)?\b/i;
            // the tag to strip from the displayed title: a () or [] group containing the word,
            // or a trailing "- Contract", ", Contract Role", "| Contractor", " Contract", etc.
            const contractTag = /\s*(\([^)]*\bcontract(or)?\b[^)]*\)|\[[^\]]*\bcontract(or)?\b[^\]]*\]|\s*[-–—,:|]\s*[^-–—,:|()[\]]*\bcontract(or)?\b[^()[\]]*$|\s+contract(or)?\s*$)/i;
            this.jobs.forEach(job => {
                if (contractWord.test(job.title)) {
                    // remove the tag
                    job.title = job.title.replace(contractTag, '').trim();
                    // mark as contract
                    if (!job.fullTime) {
                        job.fullTime = 'Contract';
                    }

                } else {
                    // mark as full-time
                    if (!job.fullTime) {
                        job.fullTime = 'Full-Time';
                    }
                }
            });
        },
        loadJobsData() {
            // Extract unique departments from the metadata (Job Family Group)
            const deptSet = new Set();
            this.jobs.forEach((job) => {
                const deptMeta = job.metadata.find(
                    (m) => m.name === "Career Page - Sub Department"
                );
                if (deptMeta && deptMeta.value) {
                    deptSet.add(deptMeta.value);
                }
            });
            this.departments = Array.from(deptSet);
        },
        getDepartment(job) {
            const deptMeta = job.metadata.find(
                (m) => m.name === "Career Page - Sub Department"
            );
            return deptMeta ? deptMeta.value : "";
        },
        openFilterSidebar() {
            this.$store.commit('openDepartmentFilter');
        },
        clearFilter() {
            this.$store.commit("setSelectedDepartmentFilters", [{label: "All Departments", slug: "all"}]);

        },
    }
}
</script>
